<template>
    <div>
        <div v-if="!componentIsLoading">
            <div class="main-container" v-if="hasArchivedVersions">
                <div v-if="!showCustomerDocuments" class="button-container">
                    <button class="btn" @click="fetchArchivedVersions()">
                        <span>Voir les archives</span>
                    </button>
                </div>
    
                <div v-else class="documents-container">
                    <div class="documents-list">
                        <div v-for="(document, idx) in customerDocuments" :key="'customer-document-' + idx" class="document-item">
                            <div class="archival-date">Archivé le {{ document.updated_at | moment-date-compact }}</div>
    
                            <div class="files-list">
                                <div v-for="(file, idx) in document.customer_document_files" :key="'customer-document-file-' + idx" class="file-item">
                                    <div class="text">
                                        <p class="index">Pièce n° {{ idx + 1 }}<span>, créé le {{ file.created_at | moment-date-compact }}</span></p>
                
                                        <p class="name">{{ truncate(file.file_name, 40) }}</p>
                                    </div>
            
                                    <div class="buttons">
                                        <a :href="getFileStreamUrl(file)" target="_blank" class="btn btn-complete btn-sm">
                                            <i class="fa fa-eye"></i>
                                            <span>Voir</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <component-loader v-else></component-loader>
    </div>
</template>

<script type="text/babel">
import ComponentLoader from 'components/ComponentLoader'
import customerDocumentFilesMixin from 'mixins/customerDocumentFiles'
import api from 'store/api'

export default {
    name:"DocumentArchivedVersionsManager",
    
    props: {
        customerDocumentId: {
            type: Number,
            required: true
        },
        hasArchivedVersions: {
            type: Boolean,
            required: true
        }
    },

    mixins: [
        customerDocumentFilesMixin
    ],
    
    data () {
        return {
            componentIsLoading: false,
            showCustomerDocuments: false,
            customerDocuments: []
        }
    },

    components: {
        ComponentLoader
    },

    mounted() {},

    computed: {},

    methods: {
        fetchArchivedVersions() {
            if (this.customerDocumentId) {
                this.componentIsLoading = true
    
                return api.getCustomerDocumentArchivedVersions(this.customerDocumentId)
                    .then((response) => {
                        this.customerDocuments = response.data.customer_documents
                        this.showCustomerDocuments = true
                        this.componentIsLoading = false
                    })
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    .main-container {
        margin: 30px 0;
    }

    .button-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .documents-container {
        .documents-list {
            display: grid;
            grid-template-columns: repeat(2, minmax(0,1fr));
            gap: 20px;

            .document-item {
                background-color: #fff;
                padding: 15px 20px;

                .archival-date {
                    font-size: 14px;
                    font-weight: 600;
                    text-align: center;
                }

                .files-list {
                    margin-top: 20px;

                    p {
                        margin-bottom: 0;
                    }

                    .file-item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 6px 8px;
                        margin-bottom: 6px;
                        border-bottom: 1px solid #ccc;

                        .index {
                            font-weight: 600;
                            font-size: 13px;
                            color: #555;

                            span {
                                font-size: 13px;
                                color: #888;
                            }
                        }
                        .name {
                            font-size: 13px;
                            color: #777;
                        }
                    }
                }
            }
        }

        @media screen and (min-width: 1600px) {
            .documents-list {
                grid-template-columns: repeat(3, minmax(0,1fr));
            }
        }
        @media screen and (min-width: 1920px) {
            .documents-list {
                grid-template-columns: repeat(4, minmax(0,1fr));
            }
        }
    }
</style>


// WEBPACK FOOTER //
// client/components/CustomerDocuments/ArchivedVersionsManager.vue